import { PlanNames } from '../../planNames';
export const stripePriceToPlanMap = {
    'price_1MdO9vA7YtA4rPbtKIWhFFOI': PlanNames.Mini,
    'price_1MdOCOA7YtA4rPbtq1EwmqFG': PlanNames.Professional,
};
//# sourceMappingURL=ashTesting.js.map